import { createFilterOptions } from "@mui/material";
import { CrossIcon } from "../../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../../constants";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import { JcKey } from "../../services/jcEntity";
import { ServiceAdvisorListApi, ServiceAdvisorUpdateUrl } from "../../services/JobCardApiCall";
var ReassignServiceAdvisor = function (props) {
    var _getLocalStorageItem, _state$ServiceAdvisor;
    var onClose = props.onClose, state = props.state;
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var formdata = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            alignItems: 'center',
            px: 2,
            py: 3,
            spacing: 0,
            rowGap: 1,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    rowGap: 0.5,
                    mb: 1.5,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: "Reassign Service Advisor",
                            fontSize: "xl",
                            fontWeight: 'strong',
                            flexDirection: "column",
                            columnSize: true
                        }, {
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CrossIcon, {
                                sx: {
                                    height: "10px",
                                    width: "10px"
                                }
                            }),
                            onClick: function () {
                                onClose();
                            },
                            columnSize: 0,
                            size: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            children: "Jobcard No.- ".concat(state === null || state === void 0 ? void 0 : state.SourceDocumentNo),
                            color: "text.tertiary",
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    columnSize: 12,
                    sx: {
                        mx: -2
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: '',
                    label: 'From Service Advisor',
                    value: (_state$ServiceAdvisor = state === null || state === void 0 ? void 0 : state.ServiceAdvisorName) !== null && _state$ServiceAdvisor !== void 0 ? _state$ServiceAdvisor : "".concat(state === null || state === void 0 ? void 0 : state.ServiceAdvisorGivenName, " ").concat(state === null || state === void 0 ? void 0 : state.ServiceAdvisorFamilyName),
                    disabled: true,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'AssignedEmployeeId',
                    label: 'To Service Advisor',
                    displayExpr: "Name",
                    valueExpr: "IdentityId",
                    filterOptions: function (options, filterState) {
                        var filteredOptions = createFilterOptions()(options, filterState);
                        return filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.filter(function (it) { return (it === null || it === void 0 ? void 0 : it.IdentityId) !== (state === null || state === void 0 ? void 0 : state.AssignedEmployeeId); });
                    },
                    getListData: ServiceAdvisorListApi,
                    apiKey: JcKey.ServiceAdvisorList,
                    apiRequest: {
                        BranchId: userOrganizationID
                    },
                    getOptionLabel: function (option) { return "".concat(option === null || option === void 0 ? void 0 : option.FirstName, " ").concat(option === null || option === void 0 ? void 0 : option.FamilyName); },
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    pt: 3,
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: true
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Cancel',
                            variant: 'outlined',
                            color: 'secondary',
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Confirm',
                            columnSize: 0,
                            variant: 'contained',
                            onClick: function () { return 'submit'; },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: this.type,
                                    disabled: !formValues.AssignedEmployeeId
                                };
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "add",
        gridProps: {
            spacing: 0
        },
        formData: formdata,
        createFormAPI: ServiceAdvisorUpdateUrl,
        createKey: JcKey.ServiceAdvisorUpdate,
        createRequest: {
            id: state === null || state === void 0 ? void 0 : state.id
        },
        onClose: function () { return onClose(); },
        pagingAPIKey: JcKey.JcPaging
    }));
};
export default ReassignServiceAdvisor;
